import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useCallback } from "react";
import { FormContent } from "../../core/FormContent/index.js";
import { FieldsContainer } from "../../core/FieldsContainer.js";
import { FormContainer } from "../../core/FormContainer/FormContainer.js";
import { FormValidationIndicator } from "../../core/FormValidationIndicator/index.js";
import { Root } from "./Root.js";
function Form(props) {
  const {
    sx,
    header,
    footer,
    testId = "form-root",
    onEnter,
    children,
    className = "",
    disableScroll = false,
    fieldsSpacing = 2,
    fieldsPadding = "0 10px",
    hideValidationIndicator = false,
    validationIndicatorProps = {},
    disablePreventDefaultOnEnterPressed
  } = props;
  const { duration, color, size = 100 } = validationIndicatorProps;
  const handleKeyPress = useCallback(
    (event) => {
      const target = event.target;
      const isEnter = event.code === "Enter" || event.key === "Enter" || event.which === 13;
      if (!isEnter) return;
      if (target.type === "textarea") return;
      let preventDefaultBehavior = !disablePreventDefaultOnEnterPressed;
      if (onEnter) {
        const allowDefaultBehavior = onEnter();
        if (typeof allowDefaultBehavior === "boolean") {
          preventDefaultBehavior = !allowDefaultBehavior;
        }
      }
      if (preventDefaultBehavior) {
        event.preventDefault();
      }
    },
    [onEnter, disablePreventDefaultOnEnterPressed]
  );
  return /* @__PURE__ */ jsx(
    Root,
    {
      "data-testid": testId,
      "data-tidal": props["data-tidal"],
      onKeyDown: handleKeyPress,
      sx,
      className,
      children: /* @__PURE__ */ jsx(FormContainer, { children: /* @__PURE__ */ jsxs(Fragment, { children: [
        !hideValidationIndicator && /* @__PURE__ */ jsx(FormValidationIndicator, { size, duration, color }),
        disableScroll ? /* @__PURE__ */ jsx(FormContent, { header, footer, disableScroll, children: /* @__PURE__ */ jsx(FieldsContainer, { children: /* @__PURE__ */ jsx(Stack, { spacing: fieldsSpacing, sx: { padding: fieldsPadding }, children }) }) }) : /* @__PURE__ */ jsx(
          FormContent,
          {
            header,
            footer,
            fixedMode: props.disableScroll === true ? void 0 : props.fixedFooterMode,
            children: /* @__PURE__ */ jsx(FieldsContainer, { children: /* @__PURE__ */ jsx(Stack, { spacing: fieldsSpacing, sx: { padding: fieldsPadding }, children }) })
          }
        )
      ] }) })
    }
  );
}
export {
  Form
};
//# sourceMappingURL=Form.js.map
